export default __webpack_public_path__ + "static/lalibrairie-s-mobile@2x-38ac1976ece006882567303a52429bdd.jpg";